<form edlFocusTrap [formGroup]="messageForm"
      (ngSubmit)="send(messageForm)">
    <div class="modal-header">
        <h4 class="modal-title">Send Message</h4>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="smSendMessage" class="form-label">Message</label>
                    <textarea id="smSendMessage" class="form-control" formControlName="Message"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-info"
                [disabled]="messageForm.invalid"
                [ladda]="busy">Send</button>
        <button type="button" class="btn btn-info"
                (click)="cancel()">Cancel</button>
    </div>
</form>